// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3wiNi","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__39AeB","gfeWrapper":"CalendarEvent_gfeWrapper__bho0M"};